import React from "react";



const CheckedRadio = () => (
    <div className="w-4 h-4 relative">
        <div className="w-4 h-4 left-0 top-0 absolute bg-slate-50 rounded-full border border-blue-700" />
        <div className="w-2.5 h-2.5 left-[3px] top-[3px] absolute bg-blue-700 rounded-full" />
    </div>
)

export default CheckedRadio;